import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrum',
  templateUrl: './breadcrum.component.html',
  styleUrls: ['./breadcrum.component.scss']
})
export class BreadcrumComponent implements OnInit {
  @Input() breadCrumData:any;
  constructor(private router:Router) { }

  ngOnInit(): void {
  }
  navigate(url) {
    this.router.navigate([url])
  }
}
